import * as React from 'react';
import TermInput from './TermInput';

function SimpleKeyboard({onTermClick, onEnterClick, onDeleteClick, onLeftClick, onRightClick}) {
	const xterms = ["x"];
	for (let i = 2; i < 10; ++i) {
		xterms.push(i + "x")
	}

	const xrow = xterms.map(term => <TermInput key={term} onClick={onTermClick} term={term} />)

	const numterms = [];
	for (let i = 1; i < 10; ++i) {
		numterms.push(i.toString());
	}

	const numrow = numterms.map(term => <TermInput key={term} onClick={onTermClick} term={term} />)

	const oprow = [];
	oprow.push(<TermInput key="←" onClick={onLeftClick} term="←" />)
	oprow.push(<TermInput key="Delete" onClick={onDeleteClick} term="Delete" />)
	oprow.push(<TermInput key="-" onClick={onTermClick} term="-" />)
	oprow.push(<TermInput key="+" onClick={onTermClick} term="+" />)
	oprow.push(<TermInput key="Enter" onClick={onEnterClick} term="Enter" />)
	oprow.push(<TermInput key="→" onClick={onRightClick} term="→" />)

	return (
		<>
			<div className="buttonrow">{xrow}</div>
			<div className="buttonrow">{numrow}</div>
			<div className="buttonrow">{oprow}</div>
		</>
	);
}

export default SimpleKeyboard;